import React from 'react';
import PropTypes from 'prop-types';
import { get } from '../Storage';
import axios from 'axios';
import CircularProgress from 'material-ui/CircularProgress';
import Withdrawal from './Withdrawal';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TableWithdrawalToolsListComponent';

var styles = AppSettings.styles;

class WithdrawalToolsList extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            error: false,
            errorMessage: "",
            data: [],
            showLoading: true,
            autoExclusion: false,
            opened: false
        }
        this.getWithdrawalTools = this.getWithdrawalTools.bind(this);
         this.realod = this.realod.bind(this);
    }

    componentDidMount() {
        this.getWithdrawalTools();
    }

    realod(){
        this.forceUpdate(()=>{
        });
    }

    getWithdrawalTools(event) {
        if (this.state.opened) {
            this.setState({
                error: false,
                errorMessage: "",
                data: [],
                autoExclusion: false,
                showLoading: true,
                opened: false
            });
            return;
        }

        this.setState({
            showLoading: true,
            opened: true
        });

        var url = AppSettings['env'].urlUserBoxGetWithdrawalTools;
        axios.get(url)
            .then(({ data, status, statusText }) => {
                var showLoading = false;
                if (data.errors.length == 0) {
                    this.setState({
                        error: false,
                        errorMessage: "",
                        data: data.payments,
                        autoExclusion: data.autoExclusion,
                        showLoading: showLoading,

                    });
                } else {
                    this.setState({
                        error: true,
                        errorMessage: "La tua sessione è scaduta",
                        data: [],
                        autoExclusion: false,
                        showLoading: showLoading,
                        opened: true
                    });
                }
            })

            .catch(function (error) {
                console.log(error);
                this.setState({
                    error: true,
                    errorMessage: "",
                    data: [],
                    showLoading: false,
                    autoExclusion: false,
                    opened: true
                });
            }.bind(this));
    }

    renderWithdrawalToolsList() {
        if (this.state.showLoading) {
            return (
                <CircularProgress style={styles.loadingIcon} />
            );
        }

        var withdrawals = [];
        if (this.state.data.length > 0) {

            this.state.data.map(function (withdrawal, i) {
                var key = withdrawal.code;
                if (AppSettings['userSettings'].preferredWithdrawal.indexOf(withdrawal.code) != -1) {
                    var key = withdrawal.code;
                    withdrawals.push(<Withdrawal key={key} withdrawal={withdrawal} reload={this.realod}></Withdrawal>);
                }
            }.bind(this));
            this.state.data.map(function (withdrawal, i) {
                if (AppSettings['userSettings'].preferredWithdrawal.indexOf(withdrawal.code) == -1) {
                    var key = withdrawal.code;
                    withdrawals.push(<Withdrawal key={key} withdrawal={withdrawal} reload={this.realod}></Withdrawal>);
                }
            }.bind(this));
        }
        
        return (           
            <ul  className="withdrawal-tools-list-wrap" id="money-tools-list-wrap">
                {withdrawals}
            </ul>
        );
    }
    render() {
        return this.renderWithdrawalToolsList();
    }
}
WithdrawalToolsList.displayName = componentName;

// PropTypes validation
WithdrawalToolsList.propTypes = {};

// default props
WithdrawalToolsList.defaultProps = {};

WithdrawalToolsList.contextTypes = {
    openLinkPopup: PropTypes.func
}

export default WithdrawalToolsList;